export default {"src":"/_next/static/media/BitAsset.516490e3.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};